export const applyPurchaseOrderProofCompletion = (purchaseOrder, proofSummary) => {
  const isComplete = String(purchaseOrder?.proofStatus || "")
    .trim()
    .toLowerCase() === "proof complete";

  return isComplete
    ? { ...(proofSummary || {}), displayStatus: "Proof Complete" }
    : proofSummary;
};
